import { useLiteAppContext } from "@app/helpers/hooks";
import type { PageEntity, PageEntityTypes } from "@app/lib/page-entity";
import type { RequestEntity } from "@app/types/app-types";

import {
  landing_pages_entities_journey_types,
  landing_pages_entities_type
} from "@data/entity-types";

const landing_entities: Array<PageEntityTypes> = Object.values(
  landing_pages_entities_type
);

export const useEntity = (): PageEntity | null => {
  const { entity } = useLiteAppContext();
  return entity;
};

function isMatchingEntity(
  entity: PageEntityTypes | RequestEntity | null | undefined,
  valid_entities: Array<PageEntityTypes>
): boolean {
  if (!entity) {
    return false;
  }
  if (typeof entity === "string") {
    return valid_entities.includes(entity);
  }
  return valid_entities.includes(entity.type);
}

export function isLandingPage(
  entity: PageEntityTypes | RequestEntity | null | undefined
): boolean {
  return isMatchingEntity(entity, landing_entities);
}

export function isJourneyPage(
  entity: PageEntityTypes | RequestEntity | null | undefined
): boolean {
  return isMatchingEntity(entity, landing_pages_entities_journey_types);
}

export function isCheckoutPage(
  entity: PageEntityTypes | RequestEntity | null | undefined
): boolean {
  return isMatchingEntity(entity, ["checkout"]);
}

export const useIsLandingPage = (): boolean => {
  const entity = useEntity();
  return isLandingPage(entity);
};

export const useIsMatchingPage = (
  matching_entities: Array<PageEntityTypes>
): boolean => {
  const entity = useEntity();
  return isMatchingEntity(entity, matching_entities);
};
